<div *ngIf="isDisplayExpandableContent; else elseContent">
    <div class="quote-detail-widget" id="consumables_summary">
      <h3 class="quote-detail-title" [ngClass]="{'collapsed':isConsumableCollapsed}"
        (click)="isConsumableCollapsed = !isConsumableCollapsed" [attr.aria-expanded]="!isConsumableCollapsed"
        aria-controls="collapse_consumables_summary">
        Consumables Summary
        <i class="fa fa-plus" aria-hidden="true"></i>
      </h3>
      <div class="order-summary-detail" id="collapse_consumables_summary" [ngbCollapse]="isConsumableCollapsed"
        data-parent="#consumables_summary">
        <div class="quote-detail-widget">
          <div class="delivery-detail">
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #elseContent>
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </ng-template>